import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/shared';
import {GroupData} from './groupData';
import { CONFIG } from '../../shared/config';
let groupsDataUrl = CONFIG.baseUrls.groupsData;


@Injectable()
export class GroupDataService {
    constructor(private httpGeneralService: HttpGeneralService) {
    }
   
    getGroupsData(groupData: GroupData) {  
           return this.httpGeneralService.add<GroupData>(groupData, `${groupsDataUrl}/all`)
    }

    addGroupData(groupData: GroupData) {
        return this.httpGeneralService.add<GroupData>(groupData, groupsDataUrl)
    }

    getGroupData(id: number) {
        return this.httpGeneralService.get(id, groupsDataUrl)
    }

    updateGroupData(groupData: GroupData) {
        return this.httpGeneralService.update<GroupData>(groupData.groupID, groupData, groupsDataUrl)
    }

    deleteGroupData(groupData: GroupData) {
        return this.httpGeneralService.delete<number>(groupData.groupID, groupsDataUrl)
    }
}
